export const wait = (time) => {
	return new Promise((res) => setTimeout(res, time));
};

let waitSingletonHandle = null;

export const waitSingleton = (time) => {

    if (waitSingletonHandle) {
        clearTimeout(waitSingletonHandle);
        waitSingletonHandle = null;
     }

	return new Promise((res) => {
        waitSingletonHandle = setTimeout(res, time)
    });
};
